import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-ui-sidebar-search',
  templateUrl: './ui-sidebar-search.component.html',
  styleUrls: ['./ui-sidebar-search.component.scss']
})
export class UiSidebarSearchComponent {
  @Input() placeholder = 'Search menu...';
  @Input() collapsed = false;
  @Output() searchChange = new EventEmitter<string>();

  onInput(event: Event): void {
    this.searchChange.emit((event.target as HTMLInputElement).value);
  }
}
